import React from 'react'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { EmptyCircleIcon } from '@/atoms/Icons/EmptyCircleIcon'
import { TitleLG, TitleXS } from '@/atoms/Text'

export interface JourneyCardProps {
  description: string
  icon: React.ReactNode
  phase: 'complete' | 'current' | 'upcoming'
  title: string
}

const JourneyCard: React.FC<JourneyCardProps> = ({ description, icon, phase = 'current', title }) => {
  return (
    <div className="flex w-full shrink-0 snap-center snap-always justify-center first:pl-6 last:pr-6 sm:w-auto sm:snap-start md:first:pl-8 md:last:pr-8 lg:first:pl-12 lg:last:pr-12 2xl:first:pl-[4.5rem] 2xl:last:pr-[4.5rem] xs:w-auto xs:snap-start">
      <div className="flex w-[200px] flex-col items-center gap-3 text-center">
        {icon}
        {phase === 'complete' ? (
          <div className="mb-1 rounded-full border border-white p-1">
            <CircleCheckIcon color1="core-oxide" color2="core-gray-950" size={32} />
          </div>
        ) : (
          <div className="rounded-full bg-core-gray-900 p-3">
            <EmptyCircleIcon color1="transparent" color2={phase === 'current' ? 'white' : 'core-gray-700'} />
          </div>
        )}
        <TitleLG weight="semibold">{title}</TitleLG>
        <TitleXS>{description}</TitleXS>
      </div>
    </div>
  )
}

export default JourneyCard
